export enum NavDirections {
    Left = 'left',
    Right = 'right',
}

export type SlideConfig = {
    tablet: number;
    desktop: number;
};
